import React, { useEffect } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { selectAllMenuItems, getMenu } from '../reducers/menu'
import Spinner from "react-bootstrap/Spinner";
import { isLoggedIn, isAdmin, getUser, logout, getSubsite } from '../reducers/auth';
import { Col, Row } from "react-bootstrap";
import styled from 'styled-components';

const ProductMenu = (props) => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const menu = useSelector(selectAllMenuItems);
  //const currentUser = useSelector(getUser);
  const currentSubsite = useSelector(getSubsite);

const StyledDiv = styled.div`
  padding-right: 10px;
  padding-left: 10px;
  &:hover {
    color: ${props.menuTextHoverColor ? props.menuTextHoverColor : "#CCCCCC"};
    // Add other hover styles as needed
  }
`;

const StyledSelectedDiv = styled.div`
  padding-right: 10px;
  padding-left: 10px;
  background-color: #FFFFFF55};
  &:hover {
    color: ${props.menuTextHoverColor ? props.menuTextHoverColor : "#CCCCCC"};
    // Add other hover styles as needed
  };
  border: 1px solid #FFFFFF55;
  border-radius: 4px;
  
`;

let redirect = props.url;

if (!redirect || redirect == "") {
  redirect = "../productlist/";
}

const menuStatus = useSelector(state => state.menu.status);

useEffect(() => {
  console.log("Getting menu for ", currentSubsite.id);
  if (menuStatus === 'idle') {
    dispatch(getMenu(currentSubsite.id));
  }
}, [menuStatus, dispatch]);


useEffect(() => {
  if (menuStatus === 'idle') {
    dispatch(getMenu(currentSubsite.id));
  }
}, [menuStatus, dispatch]);

let menuContent = [];
let secondMenuContent = [];

if (menuStatus === 'loading') {
  menuContent = <Spinner text="Loading..." />
} else if (menuStatus === 'succeeded') {
  console.log("MENU", menu);
  var count = 0;
  if (menu && menu.length > 0) {
    var halfSize = menu.length / 2;

    menuContent = menu.map((menuItem, i) => {
      console.log("Menu Item TEST ", menuItem.id, props.currentCategory, menuItem.id == props.currentCategory);
      if(menuItem.id == props.currentCategory) {
        return (<Col style={{ padding: 2, alignContent: "center", textAlign: "center" }} xs="auto"><Nav.Link style={{ fontSize: 16, color: props.menuTextColor ? props.menuTextColor : "#FFFFFF" }} activeClassName="activeMenu" onClick={() => { navigate(redirect + ("" + menuItem.id), { replace: false }); }}><StyledSelectedDiv>{menuItem.categoryName}</StyledSelectedDiv></Nav.Link></Col>);

      } else {
        return (<Col style={{ padding: 2, alignContent: "center", textAlign: "center" }} xs="auto"><Nav.Link style={{ fontSize: 16, color: props.menuTextColor ? props.menuTextColor : "#FFFFFF" }} activeClassName="activeMenu" onClick={() => { navigate(redirect + ("" + menuItem.id), { replace: false }); }}><StyledDiv>{menuItem.categoryName}</StyledDiv></Nav.Link></Col>);

      }
    });
  }

  /*    menuContent = menu.map((menuItem, i) => {
        if(i < halfSize) return;
        else return (<Nav.Link activeClassName="activeMenu" onClick={() => {navigate(redirect + ("" + menuItem.id), { replace: false });}}>{menuItem.categoryName}</Nav.Link>); 
      });
  
      secondMenuContent = menu.map((menuItem, i) => {
        if(i >= halfSize) return;
        else return (<Nav.Link activeClassName="activeMenu" onClick={() => {navigate(redirect + ("" + menuItem.id), { replace: false });}}>{menuItem.categoryName}</Nav.Link>); 
      });
  */
} else if (menuStatus === 'failed') {
  menuContent = <div>error</div>
}

return (
  <>
    <Container style={{ backgroundColor: props.menuBgColor ? props.menuBgColor : "#414141", alignContent: "center", textAlign: "center", marginLeft: "auto", marginRight: "auto" }} fluid>
      <Container className="align-items-center" style={{ alignItems: "center", alignContent: "center", textAlign: "center", marginLeft: "auto", marginRight: "auto" }}>
        <Row className="justify-content-center" >
          {menuContent}
        </Row>
      </Container>
    </Container>
  </>
);
};
export default ProductMenu;



